import { render } from "./ViewCampaignModal.vue?vue&type=template&id=56e7b8f3&scoped=true"
import script from "./ViewCampaignModal.vue?vue&type=script&lang=js"
export * from "./ViewCampaignModal.vue?vue&type=script&lang=js"

import "./ViewCampaignModal.vue?vue&type=style&index=0&id=56e7b8f3&lang=scss&scoped=true"

import exportComponent from "/builds/retina-v5/principal-frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56e7b8f3"]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import qInstall from "../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QCardSection,QSeparator,QIcon});
